import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_OTHER_RENEWABLE_ENERGY',
  CREATE: 'ADD_BUILDING_OTHER_RENEWABLE_ENERGY',
  EDIT: 'EDIT_BUILDING_OTHER_RENEWABLE_ENERGY',
  DELETE: 'DELETE_BUILDING_OTHER_RENEWABLE_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listOtherRenewableEnergyInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_OTHER_RENEWABLE_ENERGY,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addOtherRenewableEnergyToBuilding = (otherRenewableEnergyId, buildingId, quantity) => {
  const data = {
    other_renewable_energy_id: otherRenewableEnergyId,
    building_id: buildingId,
    quantity: quantity,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_OTHER_RENEWABLE_ENERGY,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editOtherRenewableEnergyInBuilding = (buildingOtherRenewableEnergyId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_OTHER_RENEWABLE_ENERGY}${buildingOtherRenewableEnergyId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeOtherRenewableEnergyFromBuilding = (buildingOtherRenewableEnergyId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_OTHER_RENEWABLE_ENERGY}${buildingOtherRenewableEnergyId}/`,
    })
      .then(() => ({ id: buildingOtherRenewableEnergyId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_other_renewable_energy_actions.js